import { PromosShareLayer } from 'www/articles/promos-articles/modules/common/toolbar/share-widget/promos-share-layer';
export class RecapShareLayer extends PromosShareLayer{
    constructor(api) {
        super(api);
    }
    get iconsListEl(){
        if(this._iconsListEl==null){
            let iconsListEl = document.createElement('ul');
            iconsListEl.appendChild(this.facebookEl)
            iconsListEl.appendChild(this.twitterEl);
            iconsListEl.appendChild(this.linkedinEl);
            this._iconsListEl = iconsListEl;
        }
        return this._iconsListEl;
    }
}
